import { BREAKPOINTS, SPACING_2, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import type { ReactNode } from 'react';
import styled from 'styled-components';

/**
 * Wrapper for multiple cards as children.
 * Please DO NOT add any extra paddings or margins in this component.
 * This component should only take care of aligment and gaps.
 * The way to handle cards aligment in this component:
 *  - Mobile: Align cards vertically.
 *  - Desktop: Align 3 cards per row, and wrap for more cards.
 */
const Container = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING_2};
  padding: 0;
  margin: 0;

  @media (min-width: ${BREAKPOINTS.SM}px) {
    display: grid;
    gap: ${SPACING_3};
    grid-template-columns: repeat(3, minmax(auto, 1fr));
  }
`;

const WrapperCardsAligner = ({ children }: { children: ReactNode }) => (
  <Container>{children}</Container>
);

export default WrapperCardsAligner;
